import React, { useEffect, useState } from "react";
import { ShareIcon } from "lucide-react";

export default function ShareButton({}) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  async function sharePlay(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();

    const shareData = {
      title: document.title,
      text: "Olha esta peça que encontrei no Teatro.app!",
      url: window.location.href,
    };

    if (!navigator.canShare) {
      console.log(`Your browser doesn't support the Web Share API.`);
      await navigator.clipboard.writeText(shareData.url);
      alert("O endereço para esta peça foi copiado. Pode colar para partilhar.");
      return;
    }

    await navigator.share(shareData);
  }

  return (
    <button onClick={sharePlay} style={{ cursor: "pointer" }} className="flex items-center gap-1">
      <span className="text-white font-medium text-sm underline">Partilhar</span>
      <ShareIcon className="w-3 h-3" />
    </button>
  );
}
